import { render, staticRenderFns } from "./CertificateToPrint.vue?vue&type=template&id=4c3bd811&scoped=true"
import script from "./CertificateToPrint.vue?vue&type=script&lang=ts"
export * from "./CertificateToPrint.vue?vue&type=script&lang=ts"
import style0 from "./CertificateToPrint.vue?vue&type=style&index=0&id=4c3bd811&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3bd811",
  null
  
)

export default component.exports